var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChannelBackendEntityAssociationCmp',{attrs:{"association-service":_vm.associationService,"entity-plural":_vm.entityPlural,"one-to-one":false,"allow-export-enabled":false}})}
var staticRenderFns = []

export { render, staticRenderFns }